import { createSelector } from 'reselect';
import { ReduxStore } from '../ducks';

export const claimAccount = (state: ReduxStore) => state.claimAccount;
export const accessCodeEmailLoadingSelector = createSelector(claimAccount, (claimAccount) => claimAccount.isLoading);
export const accessCodeEmailDataSelector = createSelector(claimAccount, (claimAccount) => claimAccount.data);
export const accessCodeEmailErrorSelector = createSelector(claimAccount, (claimAccount) => claimAccount.error);
